import { z } from 'zod';

export const languageSchema = z
  .object({
    en: z.string().optional(),
    cs: z.string().optional(),
    de: z.string().optional(),
  })
  .refine((data) => Object.values(data).some((val) => val && val.trim() !== ''), {
    message: 'Alespoň jedna z jazykových variant musí být vyplněna',
  });

export const languageSchemaOptional = z.object({
  en: z.string().optional(),
  cs: z.string().optional(),
  de: z.string().optional(),
});

export const languageSchemaRequired = z.object({
  en: z.string().nonempty({ message: 'Anglický název je povinný' }),
  cs: z.string().nonempty({ message: 'Český název je povinný' }),
  de: z.string().nonempty({ message: 'Německý název je povinný' }),
});

export const numericStringSchema = z
  .string()
  .refine((val) => !isNaN(val as unknown as number) && !isNaN(parseFloat(val)), {
    message: 'Must be a valid number',
  })
  .transform(Number);

export const amountSchema = z.preprocess(
  (val) => {
    if (val === '' || val === null) return undefined;
    return Number(val);
  },
  z.number({
    required_error: 'Hodnota nesmí být prázdná',
    invalid_type_error: 'Hodnota musí být číslo',
  }),
);
